/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * Order-history pagination defaults, shared by the server fetch (`order.server.ts`) and the client-side
 * "View more" view (`order-history-view.tsx`). They live in this dependency-free module — rather than in
 * `order.server.ts` — so the client view can import them without pulling the server module (and its SCAPI
 * client) into the browser bundle. `order.server.ts` re-exports them, so `@/lib/api/order.server` remains
 * the import surface for server code.
 */

/** Physical offset the order-history list starts from. */
export const DEFAULT_ORDERS_OFFSET = 0; // Used to retrieve the results based on a particular resource offset.

/** Orders requested per "View more" chunk. SCAPI caps getCustomerOrders `limit` at 50. */
export const DEFAULT_ORDERS_LIMIT = 10; // Maximum records to retrieve per request, not to exceed 50. Defaults to 10.
